// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"279":"13a47344","950":"b5459917"}[chunkId] + ".css";
};